<template>
	<div class="left-bar-wrapper">
		<img src="~images/leftBar_icon.jpg"/>
		<ul ref="navlist">
			<li><a @click="changeClass($event)" href="javascript:;"  data-type="parents">指数中心</a></li>
			<li>
				<a @click="changeClass($event)" href="/blockCenter/blockIndex.html?mainindex=1"  data-type="parent">板块中心</a>
				<ul>
					<li @click="changeClass($event)"><a href="/blockCenter/blockArea.html?mainindex=1&subindex=0">地区指数</a></li>
					<li @click="changeClass($event)"><a href="/blockCenter/shIndex.html?mainindex=1&subindex=1">上证指数</a></li>
					<li @click="changeClass($event)"><a href="/blockCenter/szIndex.html?mainindex=1&subindex=2">深圳指数</a></li>
					<li @click="changeClass($event)"><a href="/blockCenter/gIndex.html?mainindex=1&subindex=3">国证指数</a></li>
					<li @click="changeClass($event)"><a href="/blockCenter/llConcept.html?mainindex=1&subindex=4">麟龙概念</a></li>
				</ul>
			</li>
			<li>
				<a @click="changeClass($event)" href="javascript:;"  data-type="parent">个股中心</a>
				<ul>
					<li @click="changeClass($event)"><a href="javascript:;">沪深A股</a></li>
					<li @click="changeClass($event)"><a href="javascript:;">沪市A股</a></li>
					<li @click="changeClass($event)"><a href="javascript:;">深圳A股</a></li>
					<li @click="changeClass($event)"><a href="javascript:;">中小板</a></li>
					<li @click="changeClass($event)"><a href="javascript:;">创业板</a></li>
					<li @click="changeClass($event)"><a href="javascript:;">A+H股</a></li>
					<li @click="changeClass($event)"><a href="javascript:;">B股</a></li>
				</ul>
			</li>
			<li>
				<a @click="changeClass($event)" href="javascript:;"  data-type="parent">资金流向</a>
				<ul>
					<li @click="changeClass($event)"><a href="javascript:;">地区板块</a></li>
					<li @click="changeClass($event)"><a href="javascript:;">上证指数</a></li>
					<li @click="changeClass($event)"><a href="javascript:;">深圳指数</a></li>
					<li @click="changeClass($event)"><a href="javascript:;">国证指数</a></li>
					<li @click="changeClass($event)"><a href="javascript:;">麟龙概念</a></li>
					<li @click="changeClass($event)"><a href="javascript:;">个股流向</a></li>
				</ul>
			</li>
			<li><a @click="changeClass($event)" href="javascript:;"  data-type="parents">龙虎榜</a></li>
		</ul>
		<div class="code-box">
			<img src="~images/code.jpg"/>
			<p>扫描下载如来神涨APP</p>
		</div>
	</div>
</template>

<script type="application/ecmascript-6">
	export default {
        name: 'leftnav',
        props: {
        
        },
        data() {
       
       return {
            	index:null,
            	subindex:null,
            	url:''
            };
        },
        mounted() {
        	this.initfun();
        },
        created(){},
        methods:{
        	initfun:function(){
        		    this.url=window.location.href;
        		    this.index=this.getUrlParamsByKey(this.url,'mainindex');
        		    this.subindex=this.getUrlParamsByKey(this.url,'subindex');
        		    if (this.index!=null&&this.subindex!=null) {
        		    	$($(this.$refs)[0].navlist.children[this.index]).find('li').eq(this.subindex).addClass('active');
        		    }else if(this.index!=null&&this.subindex==null){
        		    	$($(this.$refs)[0].navlist.children[this.index]).children().addClass('active');
        		    }
        	},
        	changeClass($event){
        		var type=$($event.currentTarget).data('type');
        		if (!type) {
        			$($event.currentTarget).addClass('active');
        			$($event.currentTarget).siblings().removeClass('active');
    			    $($event.currentTarget).parents('li').prev().removeClass('active');
        		}else{
        			if (type=='parents') {
        				$($event.currentTarget).parent().addClass('active');
        				$($event.currentTarget).siblings().find('li,a').removeClass('active');
        			} else{
        				$($event.currentTarget).addClass('active');
        				$($event.currentTarget).next().find('li').removeClass('active');
        				$($event.currentTarget).parent().siblings().romoveClass('active');
        			}
	     			
     		    }
        	}
        }
    };
</script>

<style lang="scss"  scoped="scoped">
 @import '~scss/mixin';
 div.left-bar-wrapper{
 	width: 180px;
 	font-size:16px;
 	color: #000000;
 	>img{
 		margin-bottom: 25px;
 	}
 	>ul{
 		margin-bottom: 35px;
 		>li{
 			margin-bottom: 8px;
 			&.active{
 				background: url(~images/leftBar_arrow.png) no-repeat 20px center $hover-background;
 				:hover{
	 				background: url(~images/leftBar_arrow.png) no-repeat 20px center $hover-background;
	 			}
 				a{
 					color: $hover-color;
 					
 				}
 			}
 			a{
 				color: #000000;
 			}
 			>a{
 				height: 40px;
 				line-height: 40px;
 				display: block;
 				padding-left: 40px;
 				font-weight: bold;
 				&.active{
 				background: url(~images/leftBar_arrow.png) no-repeat 20px center $hover-background;
 				color: $hover-color;
 				:hover{
	 				background: url(~images/leftBar_arrow.png) no-repeat 20px center $hover-background;
	 				color: $hover-color;
	 			}
 			}
 			}
 			ul{
 				li{
 					height: 40px;
 					line-height: 40px;
 					@include transition(color,.3s);
 					:hover{
 						@include transition(color,.3s);
 						background-color: $hover-background;
 					}
 					&.active{
 						background: url(~images/leftBar_arrow.png) no-repeat 20px center $hover-background;
 						:hover{
	 						background: url(~images/leftBar_arrow.png) no-repeat 20px center $hover-background;
	 					}
 						a{
 							color: $hover-color;
 						}
 						
 					}
 					a{
 						padding-left: 40px;
 						display: block;
 						width: 100%;
 						height: 100%;
 						&:hover{
 							color: $hover-color;
 						}
 					}
 				}
 			}
 		}
 	}
 	div.code-box{
 		text-align: center;
 		padding-bottom: 30px;
 		color: #666666;
 		font-size: 14px;
 		img{
 			margin-bottom: 18px;
 		}
 	}
 }
</style>


// WEBPACK FOOTER //
// src/components/leftnav.vue